import * as React from 'react';
import { JSX } from 'react';
import { isLoggedIn } from '../core/localStorage';
import { dashboardPageUrl } from '../core/constants';
import NavigateWithAppName from './common/NavigateWithAppName';

const AnonymousOnlyRoute = ({ children }: { children: JSX.Element }) => {
	return isLoggedIn() ? <NavigateWithAppName to={dashboardPageUrl} replace /> : children;
};

export default AnonymousOnlyRoute;
